import React from 'react'

import HomeContainer from '../components/home/HomeContainer'
const HomeScreen = props => <HomeContainer {...props} />

export default HomeScreen
